import React, { useState, useEffect } from 'react';
import './App.css';
import LandingPage from './components/LandingPage';
import AdminPage from './components/AdminPage';

const MAIN_SITE_URL = process.env.REACT_APP_MAIN_SITE_URL || 'https://www.tribearcana.com';
const ADMIN_HOSTNAME = process.env.REACT_APP_ADMIN_HOSTNAME || 'admin.tribearcana.com';

const getShouldShowAdmin = () => {
  const hostname = window.location.hostname.toLowerCase();
  const pathname = window.location.pathname;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
  const isAdminHost = hostname === ADMIN_HOSTNAME;

  if (isAdminHost) {
    return true;
  }

  if (isLocalhost) {
    return pathname === '/admin' || window.location.hash === '#admin';
  }

  return pathname === '/admin';
};

function App() {
  const [showAdmin, setShowAdmin] = useState(getShouldShowAdmin());

  useEffect(() => {
    const updateAdminState = () => setShowAdmin(getShouldShowAdmin());
    const onHashChange = () => updateAdminState();

    window.addEventListener('hashchange', onHashChange);
    window.addEventListener('popstate', updateAdminState);

    return () => {
      window.removeEventListener('hashchange', onHashChange);
      window.removeEventListener('popstate', updateAdminState);
    };
  }, []);

  const closeAdmin = () => {
    if (window.location.hostname.toLowerCase() === ADMIN_HOSTNAME) {
      window.location.href = MAIN_SITE_URL;
      return;
    }

    if (window.location.pathname === '/admin') {
      window.history.pushState({}, '', '/');
    }

    window.location.hash = '';
    setShowAdmin(false);
  };

  return (
    <div className="App">
      {!showAdmin && <LandingPage />}
      {showAdmin && <AdminPage onClose={closeAdmin} />}
    </div>
  );
}

export default App;
